import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ToggleLeft, ToggleRight } from "lucide-react";

function ActionButton({ icon, text, onClick }) {
  return (
    <button
      onClick={onClick}
      className="w-full h-40 flex flex-col justify-center items-center border-2 border-gray-400 hover:border-gray-600 rounded-lg bg-white transition-all text-gray-900 text-lg font-semibold shadow-md hover:shadow-xl"
    >
      {icon}
      <span className="mt-2">{text}</span>
    </button>
  );
}

export default function AdminPanel() {
  const [showEditor, setShowEditor] = useState(false);
  const quillRef = useRef(null);
  const navigate = useNavigate();
  const [showAnnouncement, setShowAnnouncement] = useState(false);

  useEffect(() => {
    fetchAnnouncementStatus();
  }, []);

  const fetchAnnouncementStatus = async () => {
    try {
      const response = await axios.get("https://yzkz5stlh76wzugbkexmul3ba40rddkl.lambda-url.us-east-1.on.aws/get-announcement-status");
      console.log("show_anno: ", response.data.show);
      setShowAnnouncement(response.data.show); // Assuming API returns { show_anno: true/false }
    } catch (error) {
      console.error("Error fetching announcement status:", error);
    }
  };

  const toggleAnnouncementStatus = async () => {
    const newStatus = !showAnnouncement;
    setShowAnnouncement(newStatus); // Update UI immediately for better UX
    console.log(newStatus);
    try {
      await axios.post("https://ltkldcgebzgh7feerpdsyoyxgq0ruift.lambda-url.us-east-1.on.aws/update-announcement-status", { show: newStatus });
      alert(`Announcement ${newStatus ? "enabled" : "disabled"} successfully!`);
    } catch (error) {
      console.error("Error updating announcement status:", error);
      setShowAnnouncement(!newStatus); // Revert if API fails
    }
  };

  useEffect(() => {
    if (window.Quill && quillRef.current) {
      const quill = new window.Quill(quillRef.current, {
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              [{ header: [1, 2, false] }],
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              ["link", "video"], // Ensure "video" option is included
            ],
            handlers: {
              video: () => handleVideoEmbed(quill),
            },
          },
        },
      });
    }
  }, [showEditor]);

  // Function to Save Announcement
  const handleSaveAnnouncement = async () => {
    if (!quillRef.current) return;
    const announcement = quillRef.current.querySelector(".ql-editor").innerHTML;

    if (!announcement.trim()) {
      alert("Announcement cannot be empty");
      return;
    }

    try {
      await axios.post("https://556a7cdqhkfqmjijqyybgmss4m0dbuod.lambda-url.us-east-1.on.aws/save-announcement", { content: announcement });
      alert("Announcement saved successfully!");
      setShowEditor(false);
    } catch (error) {
      console.error("Error saving announcement:", error);
    }
  };

  // Function to Handle YouTube Video Embedding
  const handleVideoEmbed = (quill) => {
    const url = prompt("Enter YouTube Video URL:");

    if (url) {
      const videoId = extractYouTubeID(url);
      if (videoId) {
        const iframeEmbed = `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" 
          frameborder="0" allowfullscreen></iframe>`;
        const range = quill.getSelection();
        quill.clipboard.dangerouslyPasteHTML(range.index, iframeEmbed);
      } else {
        alert("Invalid YouTube URL");
      }
    }
  };

  // Extract YouTube Video ID from URL
  const extractYouTubeID = (url) => {
    const regex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  return (
    <div className="flex flex-col items-center p-10">
       <ActionButton 
          icon={showAnnouncement ? <ToggleRight size={40} className="text-green-600" /> : <ToggleLeft size={40} className="text-gray-600" />} 
          text={showAnnouncement ? "Disable Announcement" : "Enable Announcement"} 
          onClick={toggleAnnouncementStatus} 
        />
      <button
        onClick={() => setShowEditor(true)}
        className="mt-4 p-2 bg-green-500 text-white rounded"
      >
        Create Announcement
      </button>
      <button
        onClick={() => navigate("/")}
        className="mt-8 bg-gray-800 text-white px-6 py-3 rounded-lg hover:bg-gray-700 transition"
      >Back to Dashboard</button>

      {showEditor && (
        <div className="mt-4 w-full max-w-2xl">
          <div ref={quillRef} className="h-60"></div>
          <button
            onClick={handleSaveAnnouncement}
            className="mt-2 p-2 bg-blue-500 text-white rounded"
          >
            Save Announcement
          </button>
        </div>
      )}
    </div>
  );
}
